import config from 'constants/config'
import { getIsInFlowStep } from 'checkout/lib/utils/cruises/steps'
import moment from 'moment'
import { getCruiseTimerExpirationTimestamp } from 'lib/cruises/cruiseUtils'

function convertNumberToTwoIntegerDigits(number: number) {
  return String(number).padStart(2, '0')
}

export function getRemainingCruiseSessionTime() {
  const expirationTimestamp = getCruiseTimerExpirationTimestamp()
  const currentTimestamp = moment().toDate().getTime()
  const totalTimeRemainingInSeconds = moment(expirationTimestamp).diff(currentTimestamp, 'seconds')

  if (totalTimeRemainingInSeconds <= 0) {
    return { minutes: convertNumberToTwoIntegerDigits(0), seconds: convertNumberToTwoIntegerDigits(0) }
  }

  // calculate remaining minutes
  const minutesRemaining = (Math.floor(totalTimeRemainingInSeconds / 60))
  const formattedRemainingMinutes = convertNumberToTwoIntegerDigits(minutesRemaining)

  // calculate remaining seconds
  const minutesRemainingInSeconds = minutesRemaining * 60
  const secondsRemaining = totalTimeRemainingInSeconds - minutesRemainingInSeconds
  const formattedRemainingSeconds = convertNumberToTwoIntegerDigits(secondsRemaining)

  return { minutes: formattedRemainingMinutes, seconds: formattedRemainingSeconds, minutesRemaining }
}

export function shouldRenderCruiseSessionCountdownClock(stepId: string) {
  if (!config.ENABLE_CRUISE_SESSION_TIMER) return false
  const isInFlowStep = getIsInFlowStep(stepId)
  if (isInFlowStep) return false
  const { minutes, seconds } = getRemainingCruiseSessionTime()
  const hasRemainingTime = minutes !== '00' || seconds !== '00'
  return hasRemainingTime
}
